// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1d3eedcd","239":"b78735a1","455":"9195589f"}[chunkId] + ".chunk.js";
};